(function(root) {
  "use strict";

  const namespace = root.LegitGrails = root.LegitGrails || {};
  const consent = namespace.cookieConsent;
  const STORAGE_KEY = "utm_data";
  const EXPIRATION_MS = 6 * 30 * 86400000;
  const KEYS = ["utm_source", "utm_medium", "utm_campaign", "utm_term", "utm_content", "utm_id", "gclid"];
  const AD_KEYS = ["gclid", "dclid", "gbraid", "wbraid", "gad_source", "gclsrc", "msclkid", "fbclid", "ttclid", "rdt_cid", "oppref"];
  // Capture in the head before deferred checker/guide initialization. Keep the
  // landing URL intact so consent-aware provider tags can read UTM/click IDs.
  const pageContext = { search: root.location.search || "", referrer: document.referrer || "", host: root.location.hostname };
  let memoryData = null;
  let memoryTimestamp = null;
  let lastSyncedPayload = null;
  let started = false;

  function normalize(data) {
    const normalized = {};
    KEYS.forEach(function(key) { normalized[key] = data && typeof data[key] === "string" ? data[key] : ""; });
    return normalized;
  }

  const initialParams = new URLSearchParams(pageContext.search);
  if (KEYS.some(function(key) { return initialParams.has(key); })) {
    const incoming = {};
    KEYS.forEach(function(key) { incoming[key] = initialParams.get(key) || ""; });
    memoryData = normalize(incoming);
    memoryTimestamp = Date.now();
    // Existing project exception: local-only UTM retention before consent. A new
    // campaign replaces ALL relay-owned fields, never merges an older campaign.
    try { root.localStorage.setItem(STORAGE_KEY, JSON.stringify({ data: memoryData, timestamp: memoryTimestamp })); } catch (error) {}
  }

  function readUtmData() {
    try {
      const stored = JSON.parse(root.localStorage.getItem(STORAGE_KEY) || "null");
      if (stored && stored.data && typeof stored.data === "object" && stored.timestamp) {
        if (Date.now() - Number(stored.timestamp) <= EXPIRATION_MS) return normalize(stored.data);
        root.localStorage.removeItem(STORAGE_KEY);
      }
    } catch (error) {}
    return memoryData && Date.now() - memoryTimestamp <= EXPIRATION_MS ? normalize(memoryData) : null;
  }

  function allowed(category) {
    const state = consent.getState();
    return state.isRegionResolved && state.effectiveCategories[category] === true;
  }

  function trafficSource() {
    const data = readUtmData();
    const source = {};
    if (data) KEYS.forEach(function(key) {
      if (data[key] && (key !== "gclid" || allowed("advertisement"))) source[key] = data[key];
    });
    return Object.keys(source).length ? { traffic_source: source } : {};
  }

  let analyticsWasAllowed = false;

  /** Owns attribution cleanup; it must not depend on PostHog being installed. */
  function onConsentChange(state, detail) {
    const downgraded = detail && detail.downgradedCategories || [];
    const analyticsAllowed = state.isRegionResolved && state.effectiveCategories.analytics === true;
    // GPC can change outside the store while a bfcache page is suspended, so use
    // the last executed permission rather than recomputing the old state now.
    if (analyticsWasAllowed && !analyticsAllowed) {
      try { root.localStorage.removeItem("lg_f"); root.localStorage.removeItem("lg_p"); } catch (error) {}
      try { root.sessionStorage.removeItem("lg_s"); } catch (error) {}
    }
    analyticsWasAllowed = analyticsAllowed;
    const explicitAdDeny = state.hasExplicitConsent && state.effectiveCategories.advertisement !== true;
    const gpcDeny = state.region === "USA_CA" && root.navigator && root.navigator.globalPrivacyControl === true;
    if (!explicitAdDeny && !gpcDeny && downgraded.indexOf("advertisement") === -1) return;
    const params = new URLSearchParams(pageContext.search);
    AD_KEYS.forEach(function(key) { params.delete(key); });
    pageContext.search = params.toString() ? "?" + params.toString() : "";
    if (memoryData) memoryData.gclid = "";
  }

  function syncCartAttribution() {
    if (!allowed("analytics")) return;
    const data = readUtmData();
    if (!data) return;
    const attributes = normalize(data);
    if (!allowed("advertisement")) attributes.gclid = "";
    const payload = JSON.stringify(attributes);
    if (payload === lastSyncedPayload) return;
    lastSyncedPayload = payload;
    const routesRoot = root.Shopify && root.Shopify.routes && root.Shopify.routes.root || "/";
    try {
      Promise.resolve(root.fetch(routesRoot + "cart/update.js", {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ attributes: attributes })
      })).then(function(response) {
        if (response && response.ok === false) throw new Error("Cart attribution update failed");
      }).catch(function() { if (lastSyncedPayload === payload) lastSyncedPayload = null; });
    } catch (error) { lastSyncedPayload = null; }
  }

  function start() {
    if (started) return;
    started = true;
    document.addEventListener("legitgrails:cookie-consent-ready", syncCartAttribution);
    document.addEventListener("legitgrails:cookie-consent-changed", syncCartAttribution);
    syncCartAttribution();
  }

  consent.subscribe(onConsentChange);
  namespace.attribution = {
    start: start, syncCartAttribution: syncCartAttribution, readUtmData: readUtmData,
    trafficSource: trafficSource,
    getPageContext: function() { return Object.assign({}, pageContext); }
  };
})(window);
